<script>
import BaseCheckbox from '@/components/BaseCheckbox.vue';
import utils from '@/utils/common';
import ExchangeBidTile from '@/components/exchange/ExchangeBidTile2.vue';

export default {
  name: 'MaterialTile',
  components: { ExchangeBidTile, BaseCheckbox },
  props: {
    selected: Boolean,
    item: Object,
    editable: Boolean,
  },
  computed: {
    bids() {
      return this.item.bids.filter(b => b['@id'] !== this.item.mainBid?.['@id']);
    },
  },
  methods: {
    date(date) {
      return utils.convertDateToString(new Date(date));
    },
  },
};
</script>

<template lang="pug">
  .item
    .title Материал
    .main
      .name Наименовение: {{ item.name }}
      .desc Описание: {{ item.description }}
      .volume Объем: {{ item.volume }} {{ item.volumeUnit }}
      .category Категория: {{ item.category && item.category.name }}
      .budget Бюджет: {{ item.budget }} {{ item.budgetCurrency }}
      .deadline Дедлайн: {{ item.deadlineAt && date(item.deadlineAt) }}
      div Доставка: {{ item.delivery }}
      div Помещения: {{ item.rooms.join(', ') }}
      div Необходимость монтажа: {{ item.isAssemblyRequired ? 'Да' : 'Нет' }}
    .controls(v-if="editable")
      .editable
        BaseCheckbox(:value="selected" @change="$emit('select', $event)")
        Btn(:to="{ name:'material-form', params: { ...$route.params, id: item.id } }") Редактировать
        Btn(@click="$emit('delete')") Удалить
        Btn(@click="$emit('addBid')") + Поставщик (предложение)
        .orders Заказы:
          .order(v-for="order in item.orders") {{ order && order.name }}
            Btn(xs @click="$emit('deleteFromOrder', order && order['@id'])") X
      .bids
        ExchangeBidTile(
          v-if="item.mainBid"
          :item="item.mainBid"
          :editable="!item.mainBid.response"
          @unsetMain="$emit('unsetMainBid')"
          @edit="$emit('editBid', item.mainBid)"
          @delete="$emit('deleteBid', item.mainBid)"
          isMain
        )
        template(v-if="bids.length && bids[0]")
          ExchangeBidTile(
            v-for="bid in bids"
            :key="bid.id"
            :item="bid"
            :editable="!bid.response"
            canBeMain
            page="decor"
            @edit="$emit('editBid', bid)"
            @delete="$emit('deleteBid', bid)"
            @setMain="$emit('setMainBid', bid)"
          )
    slot
</template>

<style scoped lang="scss">
.item {
  display: grid;
  align-items: center;
  gap: 30px;
  border: 1px solid #000;
  border-radius: 30px;
  padding: 30px;
}

.title {
  font-size: 20px;
  font-weight: 700;
}

.main {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 10px;
}

.desc {
  grid-row: 4;
  grid-column: 1 / 3 span;
}

.editable {
  display: flex;
  align-items: center;
  gap: 30px;
}

.orders {
  display: flex;
  align-items: center;
  gap: 10px;
}

.bids {
  margin-top: 40px;
  display: grid;
  gap: 30px;
}
</style>
